<script>
import MethodButtonBase from './MethodButtonBase';
export default {
  name: 'FinnishTrustNetworkAdvancedFullButton',
  components: {
    MethodButtonBase,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      {{ $t('online-bank') }} (Advanced full)
    </template>
  </MethodButtonBase>
</template>
